(function () {
  'use strict';

  angular.module('wsLrs.controllers').config(['$routeProvider', function ($routeProvider) {
    $routeProvider.when('/settings/users', {
      templateUrl: 'modules/app/settings/users/users.html',
      controller: 'UsersSettingsCtrl',
      requiredPermissions: ['admin', 'manager']
    });
  }]).controller('UsersSettingsCtrl', ['$scope', 'OrganizationSettings', 'UserRoles', 'User', function ($scope, OrganizationSettings, UserRoles, User) {
    $scope.$emit("headline:change", "Settings");
    $scope.$emit("nav:change", "settings");
    $scope.availableRoles = UserRoles.getAllRoles(User.get());
    $scope.roleName = _.object(_.pluck($scope.availableRoles, 'id'), _.pluck($scope.availableRoles, 'name'));
    $scope.section = "users";
    var user = User.get();
    var canInviteUsers = true;
    OrganizationSettings.getForOrganization(user.organization.id).then(function (settings) {
      if (settings.pricingTier === "ESSENTIALS") {
        $scope.essentialsTier = true;
        $scope.availableRoles = _.filter($scope.availableRoles, function (role) {
          return role.id === "admin";
        });
      }
      canInviteUsers = OrganizationSettings.hasFeature('inviteUsers');
    });
    $scope.userAuthorizedToInvite = function () {
      return UserRoles.isOrgAdmin(user) || UserRoles.isOrgManager(user) && canInviteUsers;
    };
  }]).controller('UsersListerCtrl', ['$scope', '$controller', '$q', '$http', 'Api', 'OrganizationSettings', 'User', 'Utils', function ($scope, $controller, $q, $http, Api, OrganizationSettings, User, Utils) {
    $scope.defaultSortBy = "user.name";
    $scope.sortControls = [{
      "title": "Name",
      "options": {
        "Ascending": "user.name",
        "Descending": "-user.name"
      },
      "colspan": 2
    }, {
      "title": "Email",
      "options": {
        "Ascending": "user.email",
        "Descending": "-user.email"
      }
    }, {
      "title": "Role",
      "options": {
        "Ascending": "role",
        "Descending": "-role"
      }
    }];
    var user = User.get();
    OrganizationSettings.getForOrganization(user.organization.id).then(function (settings) {
      $scope.usesSso = Utils.filter(settings.identityProviders, function (identityProvider) {
        return identityProvider !== 'watershed';
      }).length > 0; // if any identity provider is not watershed, we will have an array with a value

      // Finish off setting up the lister headings once we get the settings and can
      // determine whether SSO is being used -- only show Type column when SSO is being used.
      if ($scope.usesSso) {
        $scope.sortControls.push({
          "title": "Type"
        });
      }
      $scope.sortControls.push({
        "title": ""
      });
    });
    $scope.getApiUrl = $scope.getApiUrl || Api.url("/filtered-memberships");
    $scope.apiUrl = $scope.apiUrl || Api.url("/memberships", true);
    $scope.formatSearchSuggestion = function formatSearchSuggestion(result) {
      return result.user.name;
    };
    $scope.isSso = function (username) {
      return username.includes('http') && username.includes('|');
    };
    $scope.processFetchResponse = function (response) {
      _.each(response.data.results, function (membership) {
        var user = membership.user;
        _.extend(user, {
          'type': $scope.isSso(user.username) ? 'SSO' : 'DIRECT'
        });
      });
      return response.data;
    };
    $scope.defaultSearchBy = ["user.name", "user.email"];
    $scope.searchPlaceholder = "Search for a user";
    $scope.hideAddModalButton = true;
    $scope.readOnly = false;
    $scope.$on("org-people-item-added-parent", function orgPeopleItemAdded(evt, newMembership) {
      newMembership.role = "user";
      $scope.$broadcast("item-added", newMembership);
    });
    $scope.$on("org-people-item-delete", function orgPeopleItemDelete(evt, index) {
      $scope.$broadcast("item-delete", index);
    });
    $controller('ListerModalBaseCtrl', {
      $scope: $scope
    });
  }]).controller('AddInvitationCtrl', ['$scope', '$uibModalInstance', 'Logger', '$http', 'Api', 'Validation', 'Utils', 'UserRoles', 'User', function ($scope, $uibModalInstance, Logger, $http, Api, Validation, Utils, UserRoles, User) {
    $scope.newUser = {};
    var user = User.get();
    $scope.newUser.role = $scope.essentialsTier ? "admin" : "user";
    $scope.save = function () {
      $scope.addUserError = null;
      $scope.addUserProgress = null;
      $scope.userFormErrors = Validation.validate({
        "name": {
          "rules": {
            "required": true
          },
          "value": $scope.newUser.name
        },
        "email": {
          "rules": {
            "required": true,
            "email": true
          },
          "value": $scope.newUser.email
        }
      });
      if ($scope.userFormErrors !== null) {
        return;
      }
      $scope.sending = true;
      var membership = {
        "user": {
          "name": $scope.newUser.name,
          "email": $scope.newUser.email
        },
        "organization": user.membership.organization,
        "invitationUrlTemplate": Utils.qualifyURL("/app/outside.html#invitation-signup/{token}"),
        "role": $scope.newUser.role
      };
      $scope.addUserProgress = "Adding " + $scope.newUser.name + " to your organization...";

      //TODO: Backend for posting to this resource needs to be filled out. Likely place, but not certain,
      //for invitation functionality. We can't ref a user by ID, it will have to be by email, and may
      //perhaps create a new user, etc.
      $http.post(Api.url("/memberships", true), membership).then(function addUserSuccess(response) {
        // Keep the url around in case we need to delete with the PK right after adding.
        var id = Utils.getIdFromCreatedResponse(response);
        $scope.sending = false;
        $scope.addUserProgress = null;

        // if it's a memberships location we added the org to an existing watershed user so not an invite.
        if (response.headers('location').indexOf("memberships") > 0) {
          membership.id = id;
          $uibModalInstance.close(['org-people-item-added', membership]);
        } else {
          $scope.newUser.id = id;
          $scope.newUser.created = new Date();
          $uibModalInstance.close(['org-invitations-item-added', $scope.newUser]);
        }
      }, function addUserError(response) {
        $scope.addUserProgress = null;
        Logger.error("Error adding user " + $scope.newUser.email + ", response status " + response.status);
        if (response.status === 409) {
          $scope.addUserError = "This user already exists in your organization.";
        } else {
          $scope.addUserError = "There was error sending the invitation";
        }
        $scope.sending = false;
      });
    };
    $scope.cancel = function () {
      $uibModalInstance.dismiss('cancel');
    };
  }]).controller('PendingInvitationsCtrl', ['$scope', '$controller', '$q', '$http', 'Api', 'Logger', function ($scope, $controller, $q, $http, Api, Logger) {
    $scope.defaultSortBy = "-created";
    $scope.sortControls = [{
      "title": "Name",
      "options": {
        "Ascending": "name",
        "Descending": "-name"
      },
      "colspan": 2
    }, {
      "title": "Email",
      "options": {
        "Ascending": "email",
        "Descending": "-email"
      }
    }, {
      "title": "When Invited",
      "options": {
        "Ascending": "created",
        "Descending": "-created"
      }
    }, {
      "title": "Role",
      "options": {
        "Ascending": "role",
        "Descending": "-role"
      }
    }, {
      "title": ""
    }];
    $scope.apiUrl = Api.url("/invitations");
    $scope.$on("org-people-item-added", function orgPeopleItemAdded(evt, newMembership) {
      //broadcast from parent scope so that UsersListerCtrl (sibling of current scope) has access to it
      $scope.$parent.$broadcast("org-people-item-added-parent", newMembership);
    });
    $scope.$on("org-invitations-item-added", function (evt, newUser) {
      $scope.$broadcast("item-added", newUser);
    });
    $scope.$on("org-invitations-item-delete", function (evt, index) {
      $scope.$broadcast("item-delete", index);
    });
    $scope.$on("org-invitations-item-delete-error", function deleteOrganizationError(evt, item, response) {
      Logger.error("Error deleting invitation " + item.id + ", response status " + response.status);
      $scope.deleteError = "There was an error deleting the invitation.";
    });
    $scope.modalOptions = {
      templateUrl: "modules/app/settings/users/modals/invite-person-modal.html",
      controller: "AddInvitationCtrl",
      backdrop: 'static',
      scope: $scope
    };
    $controller('ListerModalBaseCtrl', {
      $scope: $scope
    });
  }]).controller('UserItemCtrl', ['$scope', '$controller', 'Api', 'UserRoles', 'User', 'ConfirmModal', '$uibModal', function ($scope, $controller, Api, UserRoles, User, ConfirmModal, $uibModal) {
    $scope.getPostData = function () {
      return $scope.editCopy;
    };
    var user = User.get();
    $scope.saveSuccessEvent = "org-people-item-save";
    $scope.saveErrorEvent = "org-people-item-save-error";
    $scope.deleteSuccessEvent = "org-people-item-delete";
    $scope.deleteErrorEvent = "org-people-item-delete-error";
    $controller('ListerItemCtrl', {
      $scope: $scope
    });
    $scope.formatUserName = function (username) {
      if (username.indexOf('@ws-org') > -1) {
        return "--";
      } else if ($scope.isSso(username)) {
        var parts = username.split("|");
        return parts[1];
      } else {
        return username;
      }
    };
    $scope.edit = function () {
      var userModal = $uibModal.open({
        templateUrl: "modules/app/settings/users/modals/edit-user.html",
        controller: "EditUserCtrl",
        backdrop: 'static',
        scope: $scope
      });
      userModal.result.then(function (r) {
        if (r) {
          $scope.item.role = r.role;
        }
      });
    };
    function resetEditingState() {
      $scope.editCopy = angular.copy($scope.item);
      $scope.saving = false;
      $scope.editing = false;
      $scope.formErrors = null;
      $scope.saveError = null;
    }
    $scope.cancel = function cancel() {
      resetEditingState();
    };
    $scope.$watch('editCopy.role', function (newValue, oldValue) {
      if (newValue !== oldValue && newValue === 'admin') {
        var modal = {
          title: "Confirm",
          subtitle: null,
          body: "Changing this user to an admin will allow this user to see all data in your" + " account. Are you sure you want to continue?",
          cancelBtn: "No",
          confirmBtn: "Yes",
          cancel: function cancel() {
            $scope.editCopy.role = oldValue;
          }
        };
        ConfirmModal.open($scope, modal);
      }
    });
    var parentSaveSuccess = $scope.saveSuccess;
    $scope.saveSuccess = function () {
      $scope.item.role = $scope.editCopy.role;
      parentSaveSuccess.apply(this, arguments);
      resetEditingState();
    };
    $scope.canEdit = UserRoles.isOrgAdmin(user) || UserRoles.isOrgManager(user);
    $scope.canEdit = $scope.canEdit && $scope.item.user.id !== $scope.userId;
    resetEditingState();
  }]).controller('EditUserCtrl', ["$scope", '$uibModalInstance', 'Api', '$http', 'UserRoles', 'User', function ($scope, $uibModalInstance, Api, $http, UserRoles, User) {
    var user = User.get();
    $scope.showPermissions = !$scope.essentialsTier && (UserRoles.isOrgAdmin(user) || UserRoles.isOrgManager(user) && $scope.editCopy.role === 'user');
    $scope.person = {};
    $scope.existingPermissions = [];
    $scope.groups = [];
    $scope.onSelectGroup = function (target) {
      if (_.has(target, 'childGroupIds')) {
        if (!$scope.groups.includes(target)) {
          $scope.groups.push(target);
        }
      }
    };
    $scope.onRemove = function (g, all) {
      $scope.groups = all;
    };
    $http.get(Api.url("/users/" + $scope.editCopy.user.id + "/person")).then(function (r) {
      $scope.person = r.data;
    });
    $http.get(Api.url("/users/" + $scope.editCopy.user.id + "/permissions")).then(function (r) {
      $scope.existingPermissions = r.data;
      $scope.groups = _.map(r.data, function (p) {
        return p.target || {
          name: "All parts of your organization",
          id: 'global'
        };
      });
    });
    $scope.cancel = function () {
      $uibModalInstance.close();
    };
    $scope.save = function () {
      var existingPermissionGroupIds = _.map($scope.existingPermissions, function (p) {
        if (p.target) {
          return p.target.id;
        } else if (p.global) {
          return 'global';
        }
      });
      _.each($scope.groups, function (g) {
        if (existingPermissionGroupIds.indexOf(g.id) < 0) {
          //new permissions to create
          var global = !g || g.id === -1;
          var permission = {
            person: $scope.person,
            target: global ? null : g,
            global: global
          };
          $http.post(Api.url("group-permissions"), permission);
        }
      });
      var permissionGroupIdsToKeep = _.pluck($scope.groups, 'id');
      _.each($scope.existingPermissions, function (p) {
        if (permissionGroupIdsToKeep.indexOf(p.target ? p.target.id : 'global') < 0) {
          //permission to delete
          $http.delete(Api.url("group-permissions/" + p.id));
        }
      });
      $http.put(Api.url("/memberships/" + $scope.editCopy.id, true), $scope.editCopy).then(function success() {
        //todo: refresh edited item?
        $uibModalInstance.close($scope.editCopy);
      }, function error(r) {
        $scope.error = r;
      });
    };
  }]).controller('InvitationItemCtrl', ['$scope', '$controller', 'Api', function ($scope, $controller, Api) {
    $scope.deleteSuccessEvent = "org-invitations-item-delete";
    $scope.deleteErrorEvent = "org-invitations-item-delete-error";
    $scope.deleteApiUrl = Api.url("/invitations", true);
    $scope.updateApiUrl = Api.url("/invitations", true);
    $scope.saveSuccess = function () {
      $scope.item = $scope.editCopy;
      resetEditingState();
    };
    $scope.saveError = function () {
      $scope.saveErrorMsg = "Update failed";
    };
    $controller('ListerItemCtrl', {
      $scope: $scope
    });
    $scope.saving = false;
    $scope.edit = function () {
      $scope.editCopy = angular.copy($scope.item);
      $scope.editing = true;
    };
    $scope.getPostData = function () {
      return $scope.editCopy;
    };
    $scope.cancel = function cancel() {
      resetEditingState();
    };
    function resetEditingState() {
      $scope.saving = false;
      $scope.editing = false;
      $scope.editCopy = null;
      $scope.saveErrorMsg = null;
    }
  }]);
})();
